<template>
  <div class="contactUs">
    <div class="intrigued">{{ caption }}</div>
    <div class="contact"><router-link class="contact button" to="/contact">{{ loc.home.contact.button }}</router-link></div>
  </div>
</template>

<script>
export default {
  name: "ContactUs",
  props: {
    caption: { type: String },
  },
}
</script>

<style lang="less" scoped>
  @import "../styles/colors";
  .contactUs {
    width: 100%;
    margin-top: 40px;
    .intrigued {
      text-align: center;
      font-size: 25px;
    }
    .contact {
      text-align: center;
      font-size: 25px;
      color: @dark;
      text-decoration: none;
      padding: 5px;
      margin: 10px !important;
      .button {
        border: 1px solid;
      }
      .button:hover {
        background-color: @dark;
        color: @base;
      }
    }
  }
</style>
